import { ColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";

export class ContractsDirectDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}